module.exports = __webpack_public_path__ + "static/img/iconmenu08_white.f6a76c46.svg";